import { Injectable } from '@angular/core';

import { HelperService } from '../helper/helper.service';
import { GuestService } from '../http/guest/guest.service';

import { CustomError } from 'src/app/shared/models/api';

import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonFunctionService {
  private isCounterActiveSub$ = new BehaviorSubject<boolean>(false);
  public isCounterActive$ = this.isCounterActiveSub$.asObservable();

  constructor(
    private guestService: GuestService,
    private helperService: HelperService,
    private translateService: TranslateService
  ) {}
  deepEqual(objA: any, objB: any) {
    // Check if the types of objA and objB are the same
    if (typeof objA !== typeof objB) {
      return false;
    }

    // If both objects are primitive types or null, compare them directly
    if (objA === null || objB === null || typeof objA !== 'object') {
      return objA === objB;
    }

    // Get the keys of both objects
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);

    // Check if the number of keys is the same
    if (keysA.length !== keysB.length) {
      return false;
    }

    // Check if all keys and their values are equal
    for (const key of keysA) {
      if (!keysB.includes(key) || !this.deepEqual(objA[key], objB[key])) {
        return false;
      }
    }

    return true;
  }

  updateIncenterAppGuest(guestId: number) {
    this.guestService
      .updateIncenterAppGuest(guestId)
      .pipe()
      .subscribe({
        next: () => {
          // Success
          setTimeout(() => {
            this.helperService.showMessage(
              this.translateService.instant('toast.success'),
              this.translateService.instant('common.synchronization_with_incenter_has_been_completed_successfully')
            );
          }, 700);

          return true;
        },
        error: (err: CustomError) => {
          // Error

          setTimeout(() => {
            this.helperService.showMessage(this.translateService.instant('toast.error'), err.message);
          }, 700);

          return true;
        },
      });
  }

  setCounterActive(value: boolean) {
    this.isCounterActiveSub$.next(value);
  }
}
